import React, { useState, useEffect } from 'react';
import { Button, TextField, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { setNotifications } from '../../state/GlobalState';
import { setNotificationCount } from '../../state/GlobalState';
import { fetchNotifications } from '../../state/GlobalState';
import styles from './MyProfile.module.css';
import { setLogout } from '../../state/GlobalState';
import { isLoggedIn, doLogout } from "../../auth";
import { Grid, Box } from '@mui/material';
import { Modal } from '@mui/material';
import ModalComponent from '../ModalComponent/ModalComponent';
import { Image } from 'cloudinary-react';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Backdrop from '@mui/material/Backdrop';
import Fade from '@mui/material/Fade';
import { InputAdornment, Input, IconButton } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import { setUserDetails } from '../../state/GlobalState';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 450,
  height: 304,
  backgroundColor: 'white',
  borderRadius: '4px',
  boxShadow: 24,
  p: 4,
};

const MyProfile = ({ data }) => {


  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [opens, setOpens] = React.useState(false);
  const handleOpens = () => setOpens(true);
  const handleCloses = () => setOpens(false);

  const [passOpen, setPassOpen] = React.useState(false);
  const handlePassOpen = () => setPassOpen(true);
  const handlePassClose = () => setPassOpen(false);

  const [mobileOpen, setMobileOpen] = React.useState(false);
  const handleMobileOpen = () => setMobileOpen(true);
  const handleMobileClose = () => setMobileOpen(false);

  const [verifyOpen, setVerifyOpen] = useState(false);
  const handleVerifyOpen = () => setVerifyOpen(true);
  const handleVerifyClose = () => setVerifyOpen(false);

  const [requestEmailOpen, setRequestEmailOpen] = React.useState(false);
  const handleRequestEmailOpen = () => setRequestEmailOpen(true);
  const handleRequestEmailClose = () => setRequestEmailOpen(false);

  const [verifyMobileOpen, setVerifyMobileOpen] = useState(false);
  const handleVerifyMobileOpen = () => setVerifyMobileOpen(true);
  const handleVerifyMobileClose = () => setVerifyMobileOpen(false);

  const navigate = useNavigate();
  const name = useSelector((state) => state.globalData.name);
  const count = useSelector((state) => state.globalData.notificationCount);
  const dispatch = useDispatch();

  const token = useSelector((state) => state.globalData.token);
  const userDetails = useSelector((state) => state.globalData.userDetails);
  const [businessData, setBusinessData] = useState({
    id: userDetails?.id || "",
    name: userDetails.name || "",
    username: userDetails.email || "",
    email: userDetails.email || "",
    password: "",
    phoneNumber: userDetails.phoneNumber || "",
    dateCreated: userDetails.dateCreated || '',
    roles: userDetails.roles?.name || '',

  });
  const [showPassword, setShowPassword] = useState(false);
  const [isFieldEdited, setIsFieldEdited] = useState(false);
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');

  const handleRequestOtp = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_STEELADMIN}/api/auth/changePassword/${businessData.phoneNumber}`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          },
        }
      );
      console.log(response);
    } catch (err) {
      console.log(err);
    }
  };

  // const handleDispatch=()=>{
  //   console.log(userDetails)
   
  //   const updatedDetails = { ...userDetails, phoneNumber: "+9190000000000" }
  //   console.log(updatedDetails)
  

  //   dispatch(setUserDetails({
  //     userDetails:updatedDetails
  //   }));
  //   console.log(updatedDetails)
  // }

  const handleSubmits = async (e) => {
    e.preventDefault();

    // Make API call here to change the password
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_STEELADMIN}/api/auth/changePassword/${businessData.email}`,
        {
          oldPassword: oldPassword,
          newPassword: newPassword
        },
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          },
        }
      );

      if (response.status === 200) {
        console.log('Password changed successfully');
        handleCloses();
      } else {
        console.log('Error:', response.data.message);
      }
    } catch (error) {
      console.log('Error:', error.message);
    }
  };

  useEffect(() => {
    console.log(userDetails)
    setBusinessData({
      name: userDetails.name,
      email: userDetails.email,
      password: '',
      phoneNumber: userDetails.phoneNumber,
      username: userDetails.email,
      roles: userDetails.roles?.name,
      dateCreated: userDetails.dateCreated
    });
  }, [userDetails]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setBusinessData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setIsFieldEdited(true);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      if (!isFieldEdited) {
        navigate('/dashboard');
        // No API call if no field is edited
        return;
      }

      const requestData = {
        name: businessData.name,
        email: businessData.email,
        password: businessData.password,
        phoneNumber: businessData.phoneNumber,
        roles: { name: businessData.roles },
        username: userDetails.username,
      };

      const eventResponse = await axios.post(
        `${process.env.REACT_APP_STEELADMIN}/superAdmin/editUser/${userDetails.id}`,
        requestData,
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          },
        }
      );
     

      dispatch(fetchNotifications());
      dispatch(setNotificationCount({ count: count + 1 }));

      logout();
      // navigate('/login');
    } catch (error) {
      console.error(error);
    }
  };

  const logout = () => {
    dispatch(setLogout());
    navigate('/login');
  };

  return (
    <div className={styles.mainDiv} >
      <form onSubmit={handleSubmit}>
        <Typography variant='h1' >My Profile</Typography>
        <Typography variant='h3' sx={{ display: { xs: 'none' } }}>General Information</Typography>
        <Box sx={{ width: '100%', display: 'flex' }}>
          <Box sx={{ width: '65%', gap: '5%' }}>
            <Box sx={{ display: 'flex' }}>
              <Grid container spacing={3} className={styles.formContainer} >
                <Grid item xs={12} sm={6} lg={6}>
                  <label className={styles.nameLable}>Full Name:</label>
                  <input
                    type="text"
                    disabled
                    value={businessData?.name || ''}
                    name="name"
                    onChange={handleInputChange}
                  />
                </Grid>
                {/* <Grid item xs={12} sm={6} lg={6}>
                  <label className={styles.nameLable}>User Name:</label>
                  <input
                    type="text"
                    id="username"
                    name="username"
                    value={businessData?.username || ''}
                   
                    onChange={handleInputChange}
                  />
                </Grid> */}

                <Grid item xs={12} lg={6}>
                  <label className={styles.nameLable}>Email:</label>
                  <input
                    type="text"
                    disabled
                    value={businessData?.email || ''}
                    name="email"
                    onChange={handleInputChange}
                  />
                </Grid>

              </Grid>
            </Box>

            <Box sx={{ display: 'flex', mt: '2%' }}>
              <Grid container spacing={3} className={styles.formContainer} >

                <Grid item xs={12} lg={6}>
                  <label className={styles.nameLable}>Mobile Number:</label>
                  <TextField
                    disabled
                    fullWidth
                    type="text"
                    value={businessData?.phoneNumber || ''}
                    name="phoneNumber"
                    onChange={handleInputChange}
                    className={styles.customTextField}
                    inputProps={{
                      style: {
                        height: '5px', // Change the height value to your desired value
                      },
                    }}
                    InputProps={{
                      endAdornment: (
                        <Button
                          variant="text"
                          sx={{ textTransform: 'capitalize' }}
                          onClick={() => { handleOpen(); handleSubmits(); }}
                        >
                          Change
                        </Button>
                      ),
                    }}
                    autoComplete="off"
                  />
                  <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <Box style={style}>
                      <ModalComponent handleCloseParent={handleClose} />
                    </Box>
                  </Modal>
                </Grid>
                <Grid item xs={12} lg={6}>
                  <label className={styles.nameLable}>Registered on:</label>
                  <input
                    type="text"
                    id="number"
                    disabled
                    name="dateCreated"
                    value={businessData.dateCreated}
                    onChange={handleInputChange}
                  />
                </Grid>
              </Grid>
            </Box>

            <Box sx={{ display: 'flex', mt: '2%' }}>
              <Grid container spacing={3} className={styles.formContainer} >

                <Grid item xs={12} lg={6}>
                  <label className={styles.nameLable}>Role:</label>
                  <input
                    type="text"
                    value={businessData?.roles || ''}
                    name="roles"
                    onChange={handleInputChange}
                    disabled
                  />
                </Grid>
              </Grid>
            </Box>
          </Box>
          <Box sx={{ width: '30%' }}>
            <Grid item xs={12} lg={4} className={styles.imageContainer}>
              <Box sx={{ width: '500px' }}>
                <AccountCircleIcon sx={{ color: '#DAE6FC', fontSize: '132px', ml: { xs: '-250px', md: '20%', mt: { xs: '-25px' } } }} />
                <Button className={styles.editButton}>Edit Photo</Button>
              </Box>
              <Box>
                <Button
                  className={styles.changePass}
                  variant="outlined"
                  onClick={handleOpens}
                >
                  Change Password
                </Button>
              </Box>
              <Modal
                sx={{ p: '0% !important' }}
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={opens}
                onClose={handleCloses}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{
                  backdrop: {
                    timeout: 500,

                  },
                }}
              >
                <Fade in={opens}>
                  <Box sx={style} className={styles.modalBox} >
                    <Input
                      label="oldPassword*"
                      type='password'
                      name="oldPassword"
                      value={oldPassword}
                      placeholder="Old Password*"
                      onChange={(e) => setOldPassword(e.target.value)}
                      className={styles.modalTextfield} // Replace with the appropriate CSS class from your styles module
                      autoComplete="off"
                    style={{borderBottom:'none' }}
                      endAdornment={
                        <InputAdornment position="end" sx={{ cursor: 'pointer',textIndent:'10px',}}>
                          <IconButton
                            // onClick={() => setShowPassword(!showPassword)}
                            edge="end"
                            sx={{mr:'2%'}}
                            // aria-label={showPassword ? 'Hide password' : 'Show password'}
                          >
                            {/* {showPassword ? <VisibilityOff /> : <Visibility />} */}
                          </IconButton>
                        </InputAdornment>
                      }
                    />

                    <Input
                      className={styles.modalTextfield}
                      label="newPassword*"
                      type={showPassword ? 'text' : 'password'}
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      placeholder='newPassword'
                      autoComplete="off" // Add autocomplete attribute with a unique value
                      style={{borderBottom:'none' }}
                      endAdornment={
                        <InputAdornment position="end" sx={{ cursor: 'pointer',textIndent:'10px',}}>
                          <IconButton
                            onClick={() => setShowPassword(!showPassword)}
                            edge="end"
                            sx={{mr:'2%'}}
                            aria-label={showPassword ? 'Hide password' : 'Show password'}
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      }
                    />

                    <Button
                      onClick={handleSubmits}
                      fullWidth
                      sx={{
                        height: '40px',
                        mt: '1%',
                        padding: '10px',
                        textTransform: 'capitalize',
                        display: 'flex',
                        justifyContent: 'center',
                        textAlign: 'center',
                        bgcolorcolor: '#16469D',
                        borderRadius: '2px',
                        fontWeight: '600',
                        fontSize: '14px',
                        lineHeight: '16px'
                      }}
                      variant="contained"
                    >
                      Change
                    </Button>
                  </Box>
                </Fade>
              </Modal>
            </Grid>
          </Box>
        </Box>
        <Grid item xs={4}>
          <Button
            variant="contained"
            type="submit"
            className={styles.updateSave}
            onClick={handleRequestOtp}
          >
            Update & Save
          </Button>


         
        </Grid>
      </form>
    </div>
  );
};

export default MyProfile;
